import { Tabs, Tab, Button, Chip, Popover, PopoverContent, PopoverTrigger, } from "@heroui/react"
import { MainContainer } from "../../components/index.js"
import DashboardChart from "./DashboardChart.jsx"
import DashboardPurchase from "./DashboardPurchase.jsx"
import DashboardSale from "./DashboardSale.jsx"
import DashboardOutstanding from "./DashboardOutstanding.jsx"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useMemo, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import dayjs from "dayjs"
import { ENUM_ENCRYPT_CODE, linksUrl } from "../../constants/enum.js"
import { isMobile } from "react-device-detect"
import { toast } from "react-toastify"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCalendar, faCalendarAlt, faCalendarDays, faCalendarXmark, faChartBar, faExclamationTriangle, faListCheck, faListDots, faTruckDroplet } from "@fortawesome/free-solid-svg-icons"



function Dashboard() {
  const { rcid } = useParams();
  const [isDateDisable, setIsDateDisable] = useState(false);
  const { compCode, yearId, isReload, startDate, endDate } = useSelector((state) => state.company)

  function splitFinancialYears(startDate, endDate) {
    const result = [];

    let startYear = new Date(startDate).getFullYear();
    let endYear = new Date(endDate).getFullYear();

    for (let year = startYear; year < endYear; year++) {
      result.push({
        start: `${year}-04-01`,
        end: `${year + 1}-03-31`,
      });
    }

    return result;
  }
  // const FYStartDate = useMemo(() => getCurrentFinancialYear().start, []);
  const FY_StartDate = useMemo(() => {
    const years = splitFinancialYears(startDate, endDate);
    return years.length > 0 ? years[years.length - 1].start : startDate; // last financial year
  }, [startDate, endDate]);
  const FY_EndDate = useMemo(() => {
    const years = splitFinancialYears(startDate, endDate);
    return years.length > 0 ? years[years.length - 1].end : endDate; // last financial year
  }, [startDate, endDate]);

  // assuming currentYear is like { start: '2026-04-01', end: '2027-03-31' }
  const [filterDate, setFilterDate] = useState({
    start: dayjs(FY_StartDate).format("YYYY-MM-DD"),
    end: dayjs(FY_EndDate).format("YYYY-MM-DD")

  });
  const [propsDate, setPropsDate] = useState({
    start: dayjs(FY_StartDate).format("YYYY-MM-DD"),
    end: dayjs(FY_EndDate).format("YYYY-MM-DD")
  })


  let tabs = [
    {
      id: "chart",
      label: "Chart",
      content: <DashboardChart propDate={propsDate} />,
      icon: faChartBar
    },
    {
      id: "purchase",
      label: "Purchase",
      content: <DashboardPurchase propDate={propsDate} />,
      icon: faListCheck
    },
    {
      id: "sale",
      label: "Sale",
      content: <DashboardSale propDate={propsDate} />,
      icon: faTruckDroplet
    },
    {
      id: "outstanding",
      label: "Outstanding",
      content: <DashboardOutstanding />,
      icon: faListDots
    },
  ]

  //set payable recevable when click from main dashboard
  let isRedFrmDsbMst = ""
  if (rcid == ENUM_ENCRYPT_CODE.payable || rcid == ENUM_ENCRYPT_CODE.receivable || rcid == ENUM_ENCRYPT_CODE.difference
    || rcid == ENUM_ENCRYPT_CODE.purchase || rcid == ENUM_ENCRYPT_CODE.sale
  )
    isRedFrmDsbMst = rcid ?? ""

  const outPData = useSelector((state) => state.outstandingPayable)
  const outRData = useSelector((state) => state.outstandingReceivable)
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilterDate(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleReset = () => {
    setFilterDate({
      start: dayjs(FY_StartDate).format("YYYY-MM-DD"),
      end: dayjs(FY_EndDate).format("YYYY-MM-DD")
    })
    setPropsDate({
      start: dayjs(FY_StartDate).format("YYYY-MM-DD"),
      end: dayjs(FY_EndDate).format("YYYY-MM-DD")
    })

  }
  const handleBtnClick = () => {
    let error = ""
    const start = dayjs(filterDate.end)
    const end = dayjs(filterDate.start)
    const months = start.diff(end, 'month');
    const t_year = dayjs(FY_StartDate).format('YYYY')
    const minDate = t_year - 2 + "-" + dayjs(FY_StartDate).format('MM') + "-" + dayjs(FY_StartDate).format('DD')

    if (!dayjs(filterDate.start).isValid || !dayjs(filterDate.end).isValid ||
      filterDate.start == "Invalid date" || filterDate.end == "Invalid Date" ||
      filterDate.start == null || filterDate.end == null) {
      toast.error("Inavlid Start / End Date ", {
        "position": "top-center"
      })

    }
    else {
      if (dayjs(filterDate.start).isValid && dayjs(filterDate.end).isValid) {
        if ((dayjs(filterDate.end).format("YYYY-MM-DD") < dayjs(minDate).format("YYYY-MM-DD")) ||
          (dayjs(filterDate.start).format("YYYY-MM-DD") < dayjs(minDate).format("YYYY-MM-DD"))) {

          error += `Start / End Date must not be less than ${dayjs(minDate).format("DD-MM-YYYY")},`

        }
      }
      if (dayjs(filterDate.end).isValid && dayjs(filterDate.start).isValid) {
        if ((dayjs(filterDate.end).format("YYYY-MM-DD") > dayjs(endDate).format("YYYY-MM-DD")) ||
          (dayjs(filterDate.start).format("YYYY-MM-DD") > dayjs(endDate).format("YYYY-MM-DD"))) {

          error += `Start / End Date must not be greater than ${dayjs(endDate).format("DD-MM-YYYY")},`

        }
      }
    }
    if (months > 12) error += "Date period must not be greater than 1 year,"
    if (error == "") {
      //console.log(filterDate)
      setPropsDate(filterDate)
    }
    else {
      const messages = error.split(',');
      toast.error(
        <div>
          {messages.map((msg, idx) => msg != "" ? (
            <div key={idx} className="p-1">
              <FontAwesomeIcon className="mr-2" icon={faExclamationTriangle} ></FontAwesomeIcon>
              {msg.trim()}</div> // Trim to remove extra spaces
          ) : "")}
        </div>,
        {
          position: "top-center",
          icon: false,
          style: { whiteSpace: 'pre-line', width: '400px', fontSize: "0.8rem", color: "#da3333ff" }, // Optional here, mostly needed if using \n
        }
      );
    }
    //e.preventDefault();

  }
  const handleTabChange = (val) => {

    if (["outstanding", "sale", "purchase"].includes(val)) {
      setIsDateDisable(true)
    }
    else
      setIsDateDisable(false)
  }
  return (
    <div>
      <MainContainer pageName="Trading Dashboard">
        <div>
          {isDateDisable ? "" :
            <div className="flex justify-end  flex-wrap items-center gap-2">
              <div className="flex gap-2">
                <Chip variant="bordered" className="border-1 border-pink-500" size="sm" color="danger" > From : {dayjs(filterDate.start).format("DD-MMM-YYYY")}</Chip>
                <Chip variant="bordered" className="border-1 border-pink-500" size="sm" color="danger" > To : {dayjs(filterDate.end).format("DD-MMM-YYYY")}</Chip>
              </div>                    {/* date */}

              <Popover placement="bottom" variant="bordered"
                //isDismissable={false}
                shouldCloseOnBlur={false}
                shouldBlockScroll={true}
                shouldCloseOnScroll={false}
                showArrow={true}>
                <PopoverTrigger>
                  <Button size="sm"
                    className="bg-sky-200  text-md border-2 border-sky-500 text-sky-600 px-1" isIconOnly={true}   >
                    <FontAwesomeIcon className="text-xl" icon={faCalendarDays}></FontAwesomeIcon>
                  </Button>
                </PopoverTrigger>
                <PopoverContent className="z-[1000]">
                  <div
                    onMouseDown={(e) => e.stopPropagation()}
                    onTouchStart={(e) => e.stopPropagation()}
                  >
                    {/* <form onSubmit={handleBtnClick} > */}
                    <div className={`${isMobile ? 'flex-wrap justify-center' : ''} flex gap-2 p-4`}>
                      <div className={`flex  gap-2 `}>

                        <div className="relative">
                          <input
                            type="date"
                            name="start"
                            value={filterDate.start}
                            onChange={handleChange}
                            required
                            className="block w-full p-1 text-sm border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm bg-white"
                          />

                        </div>
                        <div className="relative">
                          <input
                            type="date"
                            name="end"
                            value={filterDate.end}
                            onChange={handleChange}
                            required
                            className="block w-full p-1  text-sm border border-slate-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 rounded-md shadow-sm bg-white"
                          />

                        </div>
                      </div>
                      <div className={`flex  gap-2 `}>
                        <Button size="sm" variant="shadow" className="bg-blue-700 h-7 text-white" onPress={handleBtnClick} >Apply</Button>
                        <Button size="sm" color="danger" variant="shadow" className=" h-7 text-white" onPress={handleReset} >Reset</Button>
                      </div>
                    </div>
                    {/* </form> */}
                  </div>
                </PopoverContent>
              </Popover>

            </div>
          }
        </div>
        <div className="flex w-full flex-col">

          <Tabs
            aria-label="Dynamic tabs"
            items={tabs}
            variant="solid"
            color="primary"
            radius="full"
            classNames={{
              tabList:
                "gap-3 bg-transparent p-0",
              tab:
                "rounded-xl border border-slate-200 bg-white px-5 py-3 shadow-sm transition-all duration-300 data-[hover=true]:shadow-md data-[hover=true]:border-orange-300",
              cursor:
                "bg-gradient-to-r from-orange-500 via-amber-500 to-orange-600 rounded-xl",
              tabContent:
                "group-data-[selected=true]:text-white font-semibold",
              panel:
                "pt-4"
            }}
            onSelectionChange={handleTabChange}
            defaultSelectedKey={
              (outPData && outPData.isFromDashboard) ||
                (outRData && outRData?.isFromDashboard) ||
                (isRedFrmDsbMst &&
                  (isRedFrmDsbMst == ENUM_ENCRYPT_CODE.receivable ||
                    isRedFrmDsbMst == ENUM_ENCRYPT_CODE.payable))
                ? "outstanding"
                : isRedFrmDsbMst && rcid == ENUM_ENCRYPT_CODE.sale
                  ? "sale"
                  : isRedFrmDsbMst && rcid == ENUM_ENCRYPT_CODE.purchase
                    ? "purchase"
                    : "chart"
            }
          >
            {(item) => (
              <Tab
                key={item.id}
                title={
                  <div className="flex items-center gap-2">

                    <div
                      className="
              flex
              h-8
              w-8
              items-center
              justify-center
              rounded-full
              bg-white/90
              shadow-sm
            "
                    >
                      <FontAwesomeIcon
                        icon={item.icon}
                        className="text-orange-600 text-sm"
                      />
                    </div>

                    <span className="font-medium">
                      {item.label}
                    </span>

                  </div>
                }
              >
                <div className="rounded-xl bg-white p-4 shadow-sm border border-slate-200">
                  {item.content}
                </div>
              </Tab>
            )}
          </Tabs>

        </div>
      </MainContainer>
    </div>
  )
}
export default Dashboard

{/* <Tabs aria-label="Dynamic tabs" variant="solid" color="primary" items={tabs} radius="none" className="font-semibold text-sm" onSelectionChange={handleTabChange} defaultSelectedKey={(outPData && outPData.isFromDashboard) || (outRData && outRData?.isFromDashboard) || (isRedFrmDsbMst && (isRedFrmDsbMst == ENUM_ENCRYPT_CODE.receivable || isRedFrmDsbMst == ENUM_ENCRYPT_CODE.payable) ) ? "outstanding" : isRedFrmDsbMst && rcid == ENUM_ENCRYPT_CODE.sale ? "sale" : isRedFrmDsbMst && rcid == ENUM_ENCRYPT_CODE.purchase ? "purchase" : "chart"} > {(item) => ( <Tab className="text-sm " key={item.id} title={ <div className="flex items-center space-x-2"> <FontAwesomeIcon className="bg-white p-2 rounded-full text-orange-600" icon={item.icon} /> <span>{item.label}</span> </div>} > <div className="bg-white"> {item.content} </div> </Tab> )} </Tabs> */ }